export default __webpack_public_path__ + "static/media/virtualjpeg-colored.b036e8c6.webp";